import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";

export const Footer = styled.div`
  margin-top: 20px;
`;

export const TermsLink = styled(Text).attrs({
  as: "a",
  type: "disclaimer"
})`
  text-decoration: underline;
`;

export const HdpTerms = styled(Text).attrs({
  type: "sm"
})`
  color: ${colors.koalaGrey};
`;

export const HdpTermsLink = styled(HdpTerms).attrs({
  as: "a"
})`
  text-decoration: underline;
`;

export const Separator = styled.hr`
  background-color: ${colors.rabbitGrey};
  margin: 20px 0;
`;
